export default function TextIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <mask
        id='mask0_7274_16525'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='20'
        height='20'
      >
        <rect width='20' height='20' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_7274_16525)'>
        <path
          d='M6.20573 16.2994V5.46604H2.03906V3.70312H12.1353V5.46604H7.96865V16.2994H6.20573ZM13.7057 16.2994V9.63271H11.2057V7.86979H17.9686V9.63271H15.4686V16.2994H13.7057Z'
          fill='#777777'
        />
      </g>
    </svg>
  );
}
